import client from '../../../config/api';
import { USERS_ADD_FAVORITE } from '../../users/actionTypes';

export default {
  async FETCH_STANDARD_TASKS({ commit }, options = {}) {
    const params = {};

    if (options?.includeLinkedWiCounts) {
      params.includeLinkedWiCounts = true;
    }

    if (options?.statusFilter && options.statusFilter.length > 0) {
      params.statusFilter = options.statusFilter;
    }

    const response = await client.get('/standard-tasks', {
      params: Object.keys(params).length > 0 ? params : undefined,
    });
    const standardTasks = response.data || [];
    commit('SET_STANDARD_TASKS', standardTasks);
    return standardTasks;
  },

  async FETCH_STANDARD_TASK(_, id) {
    const response = await client.get(`/standard-tasks/${id}`);
    return response.data;
  },

  async FETCH_DELETED_STANDARD_TASKS() {
    const response = await client.get('/standard-tasks', {
      params: { deleted: true },
    });
    return response.data || [];
  },

  async CREATE_STANDARD_TASK({ commit }, payload) {
    const response = await client.post('/standard-tasks', payload);
    const standardTask = response.data;
    commit('ADD_STANDARD_TASK', standardTask);
    return standardTask;
  },

  async UPDATE_STANDARD_TASK({ commit }, standardTask) {
    const response = await client.put(
      `/standard-tasks/${standardTask._id}`,
      standardTask
    );
    commit('UPDATE_STANDARD_TASK', response.data);
    return response.data;
  },

  async DELETE_STANDARD_TASK({ commit }, id) {
    await client.delete(`/standard-tasks/${id}`);
    commit('REMOVE_STANDARD_TASK', id);
  },

  async RESTORE_STANDARD_TASK(_, id) {
    const response = await client.put(`/standard-tasks/${id}/restore`);
    return response.data;
  },

  async ADD_STANDARD_TASK_FAVORITE({ dispatch }, { id, count }) {
    const favoriteData = await dispatch(USERS_ADD_FAVORITE, id, {
      root: true,
    });
    if (favoriteData && favoriteData.changed === false) {
      return { status: true, count, changed: false };
    }

    const nextCount = Math.max(0, Number(count) + 1);
    await client.put(`/standard-tasks/${id}`, { favoriteCount: nextCount });
    return { status: true, count: nextCount, changed: true };
  },

  async REMOVE_STANDARD_TASK_FAVORITE(_, { id, count }) {
    const favoriteData = await client.delete(`users/current/favorites/${id}`);
    if (favoriteData.data && favoriteData.data.changed === false) {
      return { status: true, count, changed: false };
    }

    const nextCount = Math.max(0, Number(count) - 1);
    await client.put(`/standard-tasks/${id}`, { favoriteCount: nextCount });
    return { status: true, count: nextCount, changed: true };
  },
};
